import { render, staticRenderFns } from "./LeaveWorkList.vue?vue&type=template&id=253ea852&scoped=true"
import script from "./LeaveWorkList.vue?vue&type=script&lang=js"
export * from "./LeaveWorkList.vue?vue&type=script&lang=js"
import style0 from "./LeaveWorkList.vue?vue&type=style&index=0&id=253ea852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253ea852",
  null
  
)

export default component.exports